export default class PDFModal {
    constructor() {
        const htmlModalPdf=`
        <div data-download class="modal-pdf modal-pdf-id">
            <div class="backshadow"></div>
            <div class="modal-content">
                <div class="block">
                    <div class="modal-pdf_form">
                        <div class="close-modal">
                            <span>&#10005;</span>
                        </div>
                        <h3>Para iniciar o download é necessário preencher o formulário</h3>
                        <form version="2.0" class="formIntegration formIntegration2 style1" accept-charset="UTF-8" method="post" onsubmit="return dinForms.ValidateForm(this)" action="https://receiver.emkt.dinamize.com/in/303509/1/5b400/0" target="DinamizeIframeFormIntegration" data-name="RG93bmxvYWQgUERGICgyMDI0KSBWMg==" >
                            <input type="hidden" name="update_mode" value="AS"/>
                            <input type="hidden" name="form-code" value="104"/>
                            <input type="hidden" name="isMsg" value="true"/>
                            <div class="DinamizeDivCaptchaMessage">Captcha obrigatório</div><div class="DinamizeDivMessageAlert"></div>
                            <div class="DinamizeDivMessageSuccess">Cadastro efetuado com sucesso!</div>
                            <div class="DinamizeDivMessageError">Complete o cadastro</div>
                            <input type="hidden" name="text-confirmation" value="Q2FkYXN0cm8gZWZldHVhZG8gY29tIHN1Y2Vzc28h"/>
                            <input type="hidden" name="text-error" value=""/>
                            <input type="hidden" name="text-alert" value=""/>
                            <input type="hidden" name="cmp4" value="Download PDF"/>
                            <input type="hidden" name="phase-change" value="off"/>
                            <div class="block1">
                                <label>Nome</label>
                                <input type="text" name="cmp2"  placeholder="Digite seu nome" format=""  class="type_VC   input-field" maxlength="80" />
                                <label>E-mail</label>
                                <input type="text" name="cmp1"  placeholder="Digite seu e-mail" format=""  class="type_EMAIL field-required  input-field" maxlength="80" />
                                <label>Telefone</label>
                                <input id="tel" type="text" name="cmp16"  placeholder="Digite seu telefone" format=""  class="type_VC   input-field" maxlength="80" />
                                <label>Selecione a(s) área(s) de seu interesse</label>
                                <div class="containerMultiple containerMultiple_cmp113 input-field " style="max-height: 100%">
                                    <select multiple="multiple" hd-name="cmp113" class="invi-select  type_LVM" ></select>
                                    <label>
                                        <input type="checkbox" class="chk_cmp113" value="Formação de Educadores"> Formação de Educadores
                                    </label>
                                    <label>
                                        <input type="checkbox" class="chk_cmp113" value="Estudos e Pesquisas"> Estudos e Pesquisas
                                    </label>
                                    <label>
                                        <input type="checkbox" class="chk_cmp113" value="Projetos Educacionais"> Projetos Educacionais
                                    </label>
                                    <label>
                                        <input type="checkbox" class="chk_cmp113" value="Doações"> Doações
                                    </label>
                                    <label>
                                        <input type="checkbox" class="chk_cmp113" value="Parcerias com Empresas"> Parcerias com Empresas
                                    </label>
                                    <input type="hidden" name="cmp113" />
                                    <input type="hidden" name="cmp113_action" value="replacement" />
                                </div>
                            </div>
                            <input type="hidden" id="urlPDF" name="cmp112"  placeholder="" format=""  class="type_VC   input-field" maxlength="80" />
                            <div class="block2">
                                <input type="checkbox" id="subscribeNews" name="subcmp79scribe" value="Sim" class="type_LVU field-required" required>
                                <label for="subscribeNews">
                                    Estou de acordo com a Lei Geral de Proteção de Dados Pessoais e <a target="_blank" href="https://institutoayrtonsenna.org.br/politica-de-privacidade/">Política de Privacidade do Instituto Ayrton Senna </a>
                                </label>
                            </div>
                            <div class="vertical class1 submit submit-button-td">
                                <input type="submit" id="submit" value="Enviar" original-value="Enviar" class="dinSubmit btn" />
                                <span class="arrow"></span>
                                <div class="spinner">
                                    <div class="bounce1"></div>
                                    <div class="bounce2"></div>
                                    <div class="bounce3"></div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        `
        document.body.insertAdjacentHTML('beforeend', htmlModalPdf)
        
        let elPDFModal = document.querySelector('.modal-pdf')
        let elCloseModal = elPDFModal.querySelectorAll('.backshadow, .close-modal')
        const callsPDFModal = document.querySelectorAll('[data-pdfid="true"]')
        const elSubmit = document.getElementById('submit')
        const formInputPDF = document.getElementById('urlPDF')
        let targetSucess = document.querySelector('.modal-pdf_form .DinamizeDivMessageSuccess')
        let targetError = document.querySelector('.modal-pdf_form .DinamizeDivMessageError')
        let spinner = document.querySelector('.spinner');
        let pdfUrl

        callsPDFModal.forEach(el => {
            el.addEventListener('click', function (event) {
                event.preventDefault()
                elPDFModal.classList.add('show')
                document.body.classList.add('no-scroll')
                pdfUrl= el.getAttribute('href');
                var elementoModal = document.querySelector('.modal-pdf_form');
                var larguraTela = window.innerWidth;
            
                if (larguraTela < elementoModal.offsetWidth) {
                    console.log('tela é menor')
                    elementoModal.classList.remove('add-scroll');
                } else {
                    console.log('tela é maior')
                    elementoModal.classList.add('add-scroll');

                }

                let nameBox = el.previousElementSibling;
                let titleElement = nameBox.querySelector('.title');

                // Verifica se o .title não existe ou está com texto vazio
                if (!titleElement || !titleElement.textContent.trim()) {
                    titleElement = el.querySelector('h3');
                }

                let titleValue = titleElement ? titleElement.textContent.trim() : '';
                formInputPDF.value = titleValue;


            })
        })
        elCloseModal.forEach(el => {
            el.addEventListener('click', function (event) {
                event.preventDefault()
                elPDFModal.classList.remove('show')
                document.body.classList.remove('no-scroll')
                targetSucess.style.display = "none"
                targetError.style.display = "none"
            })
        })

        elSubmit.addEventListener('click', function (event) {
            const observerCallback = (mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if ( window.getComputedStyle(targetSucess).display === 'block') {
                        spinner.style.display = 'block'
                        observer.disconnect();
                        setTimeout(() => {
                            elPDFModal.classList.remove('show');
                            targetSucess.style.display = "none"
                            targetError.style.display = "none"
                            document.body.classList.remove('no-scroll');
                            spinner.style.display = 'none'
                            window.open(pdfUrl, '_blank');
                        }, 3000)
                    }
                }
            };
        
            const observer = new MutationObserver(observerCallback);

            if (targetSucess) {
                observer.observe(targetSucess, { attributes: true });
            } else {
                console.error('Elemento .DinamizeDivMessageSuccess não encontrado.');
            }
        });

        document.getElementById('tel').addEventListener('input', function(event) {
            var value = event.target.value.replace(/\D/g, '');
            var formattedValue = '';

            if (value.length > 0) {
                formattedValue += '(' + value.substring(0, 2);
            }
            if (value.length > 2) {
                formattedValue += ') ' + value.substring(2, 7);
            }
            if (value.length > 7) {
                formattedValue += '-' + value.substring(7, 11);
            }

            event.target.value = formattedValue;
        });
        

        


        
    }
}
new PDFModal();